import { ReactNode } from 'react';
import { ModalEffectStyle } from './modal-effect.style';

export function ModalEffect({ component, zIndex, willLeave }: { component: ReactNode; zIndex: number; willLeave: () => void }) {
  return (
    <ModalEffectStyle.Container style={{ zIndex }}>
      <ModalEffectStyle.Mask onClick={willLeave} />
      <ModalEffectStyle.Content>{component}</ModalEffectStyle.Content>
    </ModalEffectStyle.Container>
  );
}
